export enum ToastType {
	Info,
	Warning,
	Success,
}
